/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   2/28/22
 */

import React from "react";
import {Button, Stack} from "@mui/material";
import ViewToolbar from "./ViewToolbar";
import CalendarControls from "./CalendarControls";
import AddIcon from '@mui/icons-material/Add';
import {useSelector} from "react-redux";
import {State} from "../state/store";
import EventDialog from "./EventDialog";
import {CalendarView, Employee} from "../interfaces/Global";
import GSyncButton from "./GSyncButton";

export interface ToolbarProps {
	view: CalendarView
	employees: Employee[]
	setView: (view: CalendarView) => void
	day: Date
	setDay: (day: Date) => void
}

export default function Toolbar(props: ToolbarProps) {

	const user = useSelector((s:State) => s.user);
	const [newEventDialogOpen, setNewEventDialogOpen] = React.useState(false);

	return (
		<Stack direction={"row"} sx={{ p: 1 }} justifyContent={"space-between"}>
			<Stack direction={"row"} spacing={1}>
				<CalendarControls />
			</Stack>
			<Stack direction={"row"} spacing={1} alignItems={"center"}>
				<ViewToolbar {...props} />
				<Button
					variant={"contained"}
					color={"primary"}
					size={"large"}
					startIcon={<AddIcon />}
					onClick={() => setNewEventDialogOpen(true)}
				>
					New Event
				</Button>
				<GSyncButton
					view={props.view}
					employees={props.employees}
				/>
			</Stack>
			<EventDialog
				op={"create"}
				open={newEventDialogOpen}
				onClose={() => setNewEventDialogOpen(false)}
				model={{ employeeId: user?.id }}
			/>
		</Stack>
	);

}